import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { RepositoryPercentiles } from "@/utilities/graphing/data-repository/percentiles";
import { staticImplements } from "@/utilities/static-implements";
import { DatesRange } from "@/utilities/types/dates-range";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { CycleData } from "../cycle-data/cycle-data";

@staticImplements<ResponseModelInterfaceStatic>()
export class Percentile
{
    public constructor(
        public rank: number,
        public cycleData: CycleData[],
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): Percentile
    {
        return new this(
            elem.firstChildByTag("rank").valueAsNumber(),
            elem.firstChildByTag("cycleDatas").mapForEachChildTag("cycleData", (subElem) => CycleData.makeFromXml(subElem))
        );
    }

    public pushInDataRepository(percentiles: RepositoryPercentiles): void
    {
        const dataset = percentiles.getPercentileCurve(this.rank);

        for (const cycle of this.cycleData) {
            const cycleStats = cycle.statistics?.toGraphPredictionStatistics(cycle.start, cycle.end) ?? null;

            for (const [time, value] of cycle.getValuesByDate()) {
                dataset.insertDataPoint(time, value, cycleStats);
            }

            dataset.available.add(new DatesRange(cycle.start, cycle.end));
        }
    }
}
